<template>
  <div>
    <PageHeader
      :page="page"
      has-return
      @onReturn="goBack"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <FilterManager
      ref="filter"
      v-model="filter"
      :filters="filtersHeader"
      @academicYear="onAcademicYearChange"
      @center="onCenterChange"
      @municipality="onMunicipalityChange"
      @search="search"
      class="filter-manager_extended"
      search-container-class="search-btn"
    />

    <div class="row my-3 mx-0">
      <div class="col-12">
        <CustomSeparator text="Resultados" />
      </div>
    </div>

    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No se ha encontrado resultados."
    />
    <section v-if="result" class="row mt-4 mx-0">
      <div class="col-12">
        <ResultRow
          v-for="(item, index) in result.data"
          :key="`${item.peiAtServiceId}-${index}`"
          :item="item"
          class="mb-4"
          :search="onPageChange"
        />
      </div>
      <div class="col-12">
        <Pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          :page-size="pagination.perPage"
          @pagination-go-page="onPageChange"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import mixWait from "@/mixin/loading.mixin";
import mixAlert from "@/mixin/alert.mixin";
import storeMixin from "@/mixin/storeGenerator";

import resourcesService from "@/services/resources.js";

import ResultRow from "./ResultRow";
import FilterManager from "FilterManager";
import PageHeader from "@/components/common/page/PageHeader";
import Pagination from "pagination";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import locationServices from "@/services/api/location.api";

const REFERRAL_AT_MODULE_NAME = "referral-at";
const { mapMutations, mapActions } = createNamespacedHelpers(
  REFERRAL_AT_MODULE_NAME
);
const ROUTE_NAME_FROM = "pei";

export default {
  name: "Main",
  mixins: [mixWait, mixAlert, storeMixin],
  components: {
    FilterManager,
    ResultRow,
    PageHeader,
    Pagination,
    CustomSeparator,
    CustomResultNotFound
  },
  data: () => ({
    resources: {},
    filter: {},
    catalog: {
      academicYears: [],
      caats: [],
      centers: [],
      municipalities: [],
      referralTypes: [],
      schools: [],
      statuses: []
    },
    page: {
      icon: "fas fa-user-edit",
      title: "PEI: Referidos de Asistencia Tecnológica",
      routes: ["Inicio", "PEI", "Referidos de Asistencia Tecnológica"]
    }
  }),
  computed: {
    result: {
      get() {
        return this.$store.state[REFERRAL_AT_MODULE_NAME].result;
      },
      set(value) {
        this.setResult(value);
      }
    },
    pagination: {
      get() {
        return this.$store.state[REFERRAL_AT_MODULE_NAME].pagination;
      },
      set(value) {
        this.setPagination(value);
      }
    },

    filtersHeader() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          options: this.catalog.academicYears,
          value: this.filter.academicYear,
          placeholder: "Seleccione el año",
          fieldName: "name",
          fieldKey: "id",
          clearable: false,
          class: "col-sm-12 col-md-3 mb-md-0 mb-2",
          classContainer: "w-100",
          mapParentValue: this.filter.academicYear == null,
          error: this.resources["18018"],
          validations: "required"
        },
        {
          name: "status",
          component: "CustomDropDown",
          options: this.catalog.statuses,
          value: this.filter.status,
          placeholder: "Estatus",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          class: "col-sm-12 col-md-3 mb-md-0 mb-2",
          classContainer: "w-100",
          mapParentValue: this.filter.status == null
        },
        {
          name: "sie",
          component: "CustomInput",
          value: this.filter.sie,
          placeholder:
            "Escriba Número de SIE, Número de Estudiante o Número de Referido",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          class: "col-12 col-sm-12 col-md-6",
          type: "text"
        },
        {
          name: "referredType",
          label: "Tipo de Referido:",
          component: "CustomDropDown",
          options: this.catalog.referralTypes,
          value: this.filter.referredType,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-4 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          mapParentValue: this.filter.referredType == null,
          isAdvanced: true
        },
        {
          name: "student",
          label: "Estudiante",
          component: "CustomInput",
          value: this.filter.student,
          placeholder: "Escriba Nombre de Estudiante",
          class: "col-12 col-sm-6 col-md-4 d-flex flex-column",
          type: "text",
          isAdvanced: true
        },
        {
          name: "center",
          label: "Centro:",
          component: "CustomDropDown",
          options: this.catalog.centers,
          value: this.filter.center,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-4 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          mapParentValue: this.filter.center == null,
          isAdvanced: true
        },
        {
          name: "municipality",
          label: "Municipio:",
          component: "CustomDropDown",
          options: this.catalog.municipalities,
          value: this.filter.municipality,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-4 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          mapParentValue: this.filter.municipality == null,
          isAdvanced: true
        },
        {
          name: "school",
          label: "Escuela:",
          component: "CustomDropDown",
          options: this.catalog.schools,
          value: this.filter.school,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-4 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          mapParentValue: this.filter.school == null,
          isAdvanced: true
        }
      ];
    },
    showNotResults() {
      return this.result?.data?.length == 0;
    },
    hasCenterAccessLevel() {
      return this.$store.getters.HasPermission("level.center");
    }
  },

  methods: {
    ...mapActions(["fetchResult"]),
    ...mapMutations([
      "setResult",
      "setPagination",
      "setExpanded",
      "setResetSelection"
    ]),
    goBack() {
      this.$router.push({ name: "pei" });
    },
    async onPageChange(page) {
      this.search(this.filter, page);
    },
    async search(filters, page = 1) {
      try {
        const {
          academicYear,
          center,
          municipality,
          referredType,
          school,
          sie,
          status,
          student
        } = filters;

        const mappedFilter = {
          AcademicYear: (academicYear || {}).id,
          CenterId: (center || {}).id,
          MunicipalityId: (municipality || {}).id,
          ReferralAndStudentSieId: sie,
          ReferralTypeId: (referredType || {}).id,
          SchoolId: (school || {}).id,
          ServiceStatusId: (status || {}).id,
          StudentName: student,
          Page: page,
          PageSize: 10
        };

        await this.fetchResult(mappedFilter);
      } catch (error) {
        this.ShowToast(error.message, "", "error");
      }
    },
    async fetchResources() {
      try {
        this.resources = await resourcesService.LoadValidationMessages([
          "18018",
          "21080",
          "21081",
          "21076"
        ]);
      } catch (error) {
        this.ShowToast(error.message, "", "error");
      }
    },
    async fetchAcademicYears() {
      const { data } = await this.$ApiGet(
        "api/academicyears/getatacademicyearsforworktray"
      );
      const academicYears = data.map(({ id, description }) => ({
        id,
        name: description
      }));
      this.catalog.academicYears = academicYears;
      if (this.catalog.academicYears.length) {
        this.filter.academicYear = this.catalog.academicYears[0];
      }
    },
    async fetchStatuses() {
      const { data } = await this.$ApiGet("api/code/referralStatuses");
      this.catalog.statuses = data;
    },
    async fetchReferralTypes() {
      const { data } = await this.$ApiGet("api/code/referralTypes");
      this.catalog.referralTypes = data;
    },
    async fetchCenters() {
      const academicYearId = (this.filter.academicYear || {}).id ?? 0;

      locationServices
        .getCenters({
          academicYearId: academicYearId,
          skipUserCentersFlag: this.hasCenterAccessLevel
        })
        .then(({ data }) => {
          this.catalog.centers = data;
          if (this.catalog.centers.length == 1) {
            this.filter.center = this.catalog.centers[0];
            this.fetchMunicipalities();
          }
        });
    },
    async fetchMunicipalities() {
      const academicYearId = (this.filter.academicYear || {}).id ?? 0;
      const centerId = (this.filter.center || {}).id;

      if (centerId) {
        locationServices
          .getMunicipalities({ academicYearId, centerId })
          .then(({ data }) => {
            this.catalog.municipalities = data;

            if (this.catalog.municipalities.length == 1) {
              this.filter.municipality = this.catalog.municipalities[0];
              this.fetchSchools();
            }
          });
      }
    },
    async fetchSchools() {
      const academicYearId = (this.filter.academicYear || {}).id ?? 0;
      const municipalityId = (this.filter.municipality || {}).id;

      if (municipalityId) {
        locationServices
          .getSchools({ academicYearId, municipalityId })
          .then(({ data }) => {
            this.catalog.schools = data;

            if (this.catalog.schools.length == 1) {
              this.filter.school = this.catalog.schools[0];
            }
          });
      }
    },
    async onAcademicYearChange(value) {
      this.filter.center = null;
      this.filter.municipality = null;
      this.filter.school = null;

      if (!value) return;
      await this.fetchCenters();
    },
    async onCenterChange(value) {
      this.filter.municipality = null;
      this.filter.school = null;

      if (!value) return;

      await this.fetchMunicipalities();
    },

    async onMunicipalityChange(value) {
      this.filter.school = null;

      if (!value) return;

      await this.fetchSchools();
    }
  },

  destroyed() {
    this.persistData();
  },
  mounted() {
    Promise.all([
      this.fetchResources(),
      this.fetchAcademicYears(),
      this.fetchReferralTypes(),
      this.fetchStatuses(),
      this.fetchCenters()
    ]);

    var academicYearId = this.$route.params.academicYearId;
    var studentSieId = this.$route.params.studentSieId;
    if (studentSieId) {
      this.filter.sie = studentSieId;
    }
    if (academicYearId) {
      this.filter.academicYear = this.catalog.academicYears.filter(
        x => x.id == academicYearId
      )[0];
    }
    if (this.result.data || (studentSieId && academicYearId)) {
      this.search(this.filter);
    }
  },
  beforeRouteEnter(_, from, next) {
    next(vm => {
      if (from.name === ROUTE_NAME_FROM) {
        vm.setResetSelection();
        vm.filter = {};
        vm.shouldRecovery = false;
      } else {
        vm.recoveryData();
      }
    });
  }
};
</script>
<style scoped lang="scss">
::v-deep {
  .filter-manager_extended {
    border-radius: 0.25rem;
    @media only screen and (min-width: 750px) {
      .search-btn {
        &.col-lg-3 {
          flex: 0 0 10%;
          max-width: 10%;
          padding-left: 0;
        }
      }
    }
  }
}
</style>
